import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'sharedComponents/Icon';
import { Button, Typography } from '@material-ui/core';

import { useTranslation } from 'react-i18next';
import useStyles from './useStyles';

const ActionComponent = props => {
  const { onClick, isInFavorites, isInWaitlist, isLoading } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  if (isInFavorites) {
    return (
      <div>
        <Typography variant="subtitle1" color="secondary">
          {t(
            'components.LoanOfficerRealEstateAgents.RealEstateAgentsList.RealEstateAgentCard.ActionComponent.inFavorites',
          )}
        </Typography>
      </div>
    );
  }

  if (isInWaitlist) {
    return (
      <div>
        <Typography variant="subtitle1" color="secondary">
          {t(
            'components.LoanOfficerRealEstateAgents.RealEstateAgentsList.RealEstateAgentCard.ActionComponent.inWaitlist',
          )}
        </Typography>
      </div>
    );
  }

  return (
    <Button
      startIcon={<Icon name="add" className={classes.addIcon} />}
      onClick={onClick}
      className={classes.button}
      disabled={isLoading}
    >
      {t('components.LoanOfficerRealEstateAgents.RealEstateAgentsList.RealEstateAgentCard.ActionComponent.button')}
    </Button>
  );
};

ActionComponent.propTypes = {
  onClick: PropTypes.func.isRequired,
  isInFavorites: PropTypes.bool.isRequired,
  isInWaitlist: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default ActionComponent;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerRealEstateAgents/components/RealEstateAgentsList/components/RealEstateAgentCard/components/ActionComponent/ActionComponent.js